import controller from './controller';
import template from './template.html';

const controllerAs = 'usersBasicTable';
const bindings = {
  ngModel: '<',
  title: '<',
  message: '<',
  messageTwo: '<',
  messageThree: '<',
  messageFour: '<',
  button: '<',
  action: '&',
  deactivate: '&',
  activate: '&',
  duplicate: '&',
  remove: '&',
  changePassword: '&',
  changeEmail: '&',
  ssoDisable: '<'
};
export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/tables/usersBasic/index.js